import React, { useState } from "react";
import PropTypes from "prop-types";
import Btn from "../../../../../components/atoms/Btn";

function SequenceView({ sequence: seq }) {
  const shouldTrunc = seq?.length > 50;
  const truncSeq = shouldTrunc ? `${seq.slice(0, 2)}...${seq.slice(-2)}` : null;
  const [isShowFull, setIsShowFull] = useState(!shouldTrunc);
  const cl = "tw-uppercase tw-max-w-60 tw-text-left tw-break-all";

  return truncSeq ? (
    <Btn
      data-testid="toggle-seq"
      onSubmit={() => setIsShowFull(!isShowFull)}
      data-tooltip={
        isShowFull
          ? "click to hide whole sequence"
          : "click to view whole sequence"
      }
    >
      {truncSeq && !isShowFull ? (
        <div
          data-testid="truncated-seq"
          className={`${cl} tw-underline tw-cursor-pointer`}
        >
          {truncSeq} ({seq.length} <span className="tw-lowercase">bp</span>)
        </div>
      ) : (
        <div className={`${cl} tw-cursor-pointer`}>{seq}</div>
      )}
    </Btn>
  ) : (
    <span className={cl}>{seq}</span>
  );
}

SequenceView.propTypes = {
  sequence: PropTypes.string.isRequired,
};

export default SequenceView;
